// Who is signed in to the admin console.
//
// admin - full access
// sales - read-only: sees dealers, users and bids but cannot change anything.
//         The backend enforces this (isAdminOrSales on reads, isAdmin on
//         writes); hiding buttons here only keeps the UI honest.
// signups - sees only the customer signup list (/admin/signups). The backend
//         lets this role read the user list and nothing else (canViewSignups).
//
// Read from the persisted vuex state, the same place the router guard reads.

export function adminType() {
  try {
    const raw = localStorage.getItem("vuex");
    if (!raw) return null;
    return JSON.parse(raw)?.user?.user?.type || null;
  } catch (e) {
    return null;
  }
}

export const isAdmin = () => adminType() === "admin";
export const isSales = () => adminType() === "sales";
export const isSignupsViewer = () => adminType() === "signups";
// Anyone allowed into the admin console at all
export const isAdminConsoleUser = () => isAdmin() || isSales() || isSignupsViewer();
// Only admins may change data
export const canEditAdmin = isAdmin;

// Signed-in user's id (same persisted vuex state).
export function adminUserId() {
  try {
    const u = JSON.parse(localStorage.getItem("vuex") || "null")?.user?.user;
    return u?._id || u?.id || null;
  } catch (e) {
    return null;
  }
}
